module.exports = __webpack_public_path__ + "videos/whats-new-53-hero_16x9_en.84e459b.mp4";